import { Outlet, useLocation } from 'react-router-dom'
import BetKalkulatoriLista from '../components/BetKalkulatoriLista'
import classes from './betKalkulatoriLayout.module.css'
import useIsMobile from '../hooks/useIsMobile'
import TitleWrapper from '../betKalkulatori/redesign/components/TitleWrapper'
import { getTitleFromRoute } from '../utils/getTitleFromRoute'

const BetKalkulatorLayout = () => {
  const isMobile = useIsMobile(1024)
  const location = useLocation()
  const title = getTitleFromRoute(location.pathname)

  return (
    <div className={classes.container}>
      {!isMobile && (
        <div className={classes.sidebar}>
          <BetKalkulatoriLista />
        </div>
      )}
      <div className={classes.content}>
        <TitleWrapper title={title} />
        <Outlet />
      </div>
    </div>
  )
}

export default BetKalkulatorLayout
